import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from 'sonner';
// Themed toast host. Use `import { toast } from 'sonner'` to fire toasts.
export function Toaster() {
    return (_jsx(Sonner, { position: "bottom-right", richColors: true, toastOptions: {
            classNames: {
                toast: 'rounded-lg border border-border bg-card text-foreground text-sm',
            },
        } }));
}
export { toast } from 'sonner';
